module.exports = __webpack_public_path__ + "static/media/Gued_Mauricio_Fuentes_Trujillo.243fb5c8.jpg";